import $ from 'jquery';
import * as language from './lang';
import configLang from './configLang';
import api from './api';
import { getParam } from 'utilsES';
import { initBindEvent } from './event';
import '../favicon.png'
import { sdkOpenLink, isSdk } from './sdkCtrl'
import '../img/slider/vi-slider-1.jpg'
import '../img/slider/vi-slider-2.jpg'
import '../img/slider/vi-slider-3.jpg'
import '../img/slider/vi-slider-4.jpg'
import '../img/slider/th-slider-1.jpg'
import '../img/slider/th-slider-2.jpg'
import '../img/slider/th-slider-3.jpg'
import '../img/slider/th-slider-4.jpg'
export const quizArr = [];

export const bagArr = ["16-1", "16-2", "16-3", "16-4", "16-5", "16-6", "16-7", "16-8", "16-9", "16-10", "16-11", "16-12", "16-13", "16-14", "16-15", "16-16", "16-17", "16-18", "16-19", "16-20", "16-21", "16-22", "16-23", "16-24", "16-25", "16-26", "16-27", "16-28", "16-29", "16-30", "16-31", "16-32", "8-1", "8-2", "8-3", "8-4", "8-5", "8-6", "8-7", "8-8", "8-9", "8-10", "8-11", "8-12", "8-13", "8-14", "8-15", "8-16", "4-1", "4-2", "4-3", "4-4", "4-5", "4-6", "4-7", "4-8", "1-1", "1-2", "1-3", "1-4", "2-1", "2-2"];
export const vibagArr = ["16-1", "16-2", "16-3", "16-4", "16-5", "16-6", "16-7", "16-8", "16-9", "16-10", "16-11", "16-12", "16-13", "16-14", "16-15", "16-16", "8-1", "8-2", "8-3", "8-4", "8-5", "8-6", "8-7", "8-8", "4-1", "4-2", "4-3", "4-4", "1-1", "1-2"];
export const thbagArr = ["16-17", "16-18", "16-19", "16-20", "16-21", "16-22", "16-23", "16-24", "16-25", "16-26", "16-27", "16-28", "16-29", "16-30", "16-31", "16-32", "8-9", "8-10", "8-11", "8-12", "8-13", "8-14", "8-15", "8-16", "4-5", "4-6", "4-7", "4-8", "1-3", "1-4"];
export const numMap = {
    '16-1': {
        id: '16-1',
        session: 'session1',
        name: 'Thế Gia',
        award: 'award1',
        point: 0,
        headicon: 'head-icon1',
    },
    '16-2': {
        id: '16-2',
        session: 'session1',
        name: 'We Are One',
        award: 'award1',
        point: 0,
        headicon: 'head-icon2',
    },
    '16-3': {
        id: '16-3',
        session: 'session1',
        name: 'THẦN GIỚI',
        award: 'award1',
        point: 0,
        headicon: 'head-icon3',
    },
    '16-4': {
        id: '16-4',
        session: 'session1',
        name: 'Ae Quốc Dân',
        award: 'award1',
        point: 0,
        headicon: 'head-icon4',
    },
    '16-5': {
        id: '16-5',
        session: 'session1',
        name: 'Tula',
        award: 'award1',
        point: 0,
        headicon: 'head-icon5',
    },
    '16-6': {
        id: '16-6',
        session: 'session1',
        name: 'HọcViệnBấtỔn',
        award: 'award1',
        point: 0,
        headicon: 'head-icon6',
    },
    '16-7': {
        id: '16-7',
        session: 'session1',
        name: 'Đường Môn',
        award: 'award1',
        point: 0,
        headicon: 'head-icon7',
    },
    '16-8': {
        id: '16-8',
        session: 'session1',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: 'head-icon8',
    },
    '16-9': {
        id: '16-9',
        session: 'session1',
        name: 'Unkillable Blue',
        award: 'award1',
        point: 0,
        headicon: 'head-icon9',
    },
    '16-10': {
        id: '16-10',
        session: 'session1',
        name: 'Dragon',
        award: 'award1',
        point: 0,
        headicon: 'head-icon10',
    },
    '16-11': {
        id: '16-11',
        session: 'session1',
        name: 'Slayers',
        award: 'award1',
        point: 0,
        headicon: 'head-icon11',
    },
    '16-12': {
        id: '16-12',
        session: 'session1',
        name: 'Hải Thần',
        award: 'award1',
        point: 0,
        headicon: 'head-icon12',
    },
    '16-13': {
        id: '16-13',
        session: 'session1',
        name: 'Thần Vương',
        award: 'award1',
        point: 0,
        headicon: 'head-icon13',
    },
    '16-14': {
        id: '16-14',
        session: 'session1',
        name: 'Dạ Xoa',
        award: 'award1',
        point: 0,
        headicon: 'head-icon14',
    },
    '16-15': {
        id: '16-15',
        session: 'session1',
        name: 'Vạn Kiếm Tôn',
        award: 'award1',
        point: 0,
        headicon: 'head-icon15',
    },
    '16-16': {
        id: '16-16',
        session: 'session1',
        name: 'ＳＯＳ',
        award: 'award1',
        point: 0,
        headicon: 'head-icon16',
    },
    '16-17': {
        id: '16-17',
        session: 'session1',
        name: 'เขตแดนสังหาร',
        award: 'award1',
        point: 0,
        headicon: 'head-icon1',
    },
    '16-18': {
        id: '16-18',
        session: 'session1',
        name: 'TIANLONG',
        award: 'award1',
        point: 0,
        headicon: 'head-icon2',
    },
    '16-19': {
        id: '16-19',
        session: 'session1',
        name: 'BearMaster',
        award: 'award1',
        point: 0,
        headicon: 'head-icon3',
    },
    '16-20': {
        id: '16-20',
        session: 'session1',
        name: 'OutLaw',
        award: 'award1',
        point: 0,
        headicon: 'head-icon4',
    },
    '16-21': {
        id: '16-21',
        session: 'session1',
        name: 'อัสนีบาต',
        award: 'award1',
        point: 0,
        headicon: 'head-icon5',
    },
    '16-22': {
        id: '16-22',
        session: 'session1',
        name: 'Valhalla',
        award: 'award1',
        point: 0,
        headicon: 'head-icon6',
    },
    '16-23': {
        id: '16-23',
        session: 'session1',
        name: 'SULTAN',
        award: 'award1',
        point: 0,
        headicon: 'head-icon7',
    },
    '16-24': {
        id: '16-24',
        session: 'session1',
        name: 'ทูตสวรรค์',
        award: 'award1',
        point: 0,
        headicon: 'head-icon8',
    },
    '16-25': {
        id: '16-25',
        session: 'session1',
        name: 'เทพธิดามังกร',
        award: 'award1',
        point: 0,
        headicon: 'head-icon9',
    },
    '16-26': {
        id: '16-26',
        session: 'session1',
        name: 'วิมๅนอสูร',
        award: 'award1',
        point: 0,
        headicon: 'head-icon10',
    },
    '16-27': {
        id: '16-27',
        session: 'session1',
        name: 'lทwสัjหาs',
        award: 'award1',
        point: 0,
        headicon: 'head-icon11',
    },
    '16-28': {
        id: '16-28',
        session: 'session1',
        name: 'VENOM',
        award: 'award1',
        point: 0,
        headicon: 'head-icon12',
    },
    '16-29': {
        id: '16-29',
        session: 'session1',
        name: 'Tayz',
        award: 'award1',
        point: 0,
        headicon: 'head-icon13',
    },
    '16-30': {
        id: '16-30',
        session: 'session1',
        name: 'ΛʟαѕŦօя',
        award: 'award1',
        point: 0,
        headicon: 'head-icon14',
    },
    '16-31': {
        id: '16-31',
        session: 'session1',
        name: 'WWEZ',
        award: 'award1',
        point: 0,
        headicon: 'head-icon15',
    },
    '16-32': {
        id: '16-32',
        session: 'session1',
        name: 'Regency',
        award: 'award1',
        point: 0,
        headicon: 'head-icon16',
    },
    '8-1': {
        id: '8-1',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-2': {
        id: '8-2',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-3': {
        id: '8-3',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-4': {
        id: '8-4',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-5': {
        id: '8-5',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-6': {
        id: '8-6',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-7': {
        id: '8-7',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-8': {
        id: '8-8',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-9': {
        id: '8-9',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-10': {
        id: '8-10',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-11': {
        id: '8-11',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-12': {
        id: '8-12',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-13': {
        id: '8-13',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-14': {
        id: '8-14',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-15': {
        id: '8-15',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '8-16': {
        id: '8-16',
        session: 'session2',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '4-1': {
        id: '4-1',
        session: 'session3',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '4-2': {
        id: '4-2',
        session: 'session3',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '4-3': {
        id: '4-3',
        session: 'session3',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '4-4': {
        id: '4-4',
        session: 'session3',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '4-5': {
        id: '4-5',
        session: 'session3',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '4-6': {
        id: '4-6',
        session: 'session3',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '4-7': {
        id: '4-7',
        session: 'session3',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '4-8': {
        id: '4-8',
        session: 'session3',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '1-1': {
        id: '1-1',
        session: 'session4',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '1-2': {
        id: '1-2',
        session: 'session4',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '1-3': {
        id: '1-3',
        session: 'session4',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '1-4': {
        id: '1-4',
        session: 'session4',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '2-1': {
        id: '2-1',
        session: 'session3',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
    '2-2': {
        id: '2-2',
        session: 'session3',
        name: '???',
        award: 'award1',
        point: 0,
        headicon: '',
    },
}

export const state = {
    lang: 'vi',
    isTh: false,//是否泰国地区
    isLogin: false,//是否登录
    account: '',
    roleInfo: {
        id: '',
        sid: '',
        rid: '',
        sname: '',
        rname: ''
    },
    isBind: false,//是否绑定
    quizMatch: {},
    matchInfo: {},
    serverList: [],
    isActivityEnd: false, // 活动是否已结束
    matchId: '',
    curZan: '',
    liveLink: {},
    replayLink: [],
};
let ltbClass = '';
let rtbClass = '';
const hostname = window.location.hostname;
let arr = hostname.split(".");

if (isSdk) {
    state.lang = getParam('appLanguage') || window.navigator.language || window.navigator.browserLanguage || window.navigator.systemLanguage;
    state.lang = state.lang.toLowerCase();
    state.lang = !state.lang ? 'vi' : state.lang; // 如果是undefined的话就用默认
    if (state.lang.includes("th")) {
        state.isTh = true;
    }
} else {
    if (arr[1] == "37games") {
        state.lang = 'th';
        state.isTh = true;
    } else {
        state.lang = 'vi';
    }
}

function setLang(langs, type = 'lang') {
    let realLang = '';
    let keyArr = [...Object.keys(language.lang)];
    for (let i of keyArr) {
        if (i.includes(langs)) {
            realLang = i;
            break;
        }
    }
    realLang = realLang === '' ? 'vi-vn' : realLang;
    return language[type][realLang] ? language[type][realLang] : language[type]['vi-vn'];
}
export function initLang(langs) {
    if (langs.includes("th")) {
        $("body").removeClass("vi").addClass("th");
        $("html").attr("lang", "th")
        for (let i = 1; i < 5; i++) {
            $('.j-img-' + i).attr('src', '/dlssrvtline2/img/th-slider-' + i + '.jpg')
        }
    } else {
        $("body").removeClass("th").addClass("vi");
        $("html").attr("lang", "vi")
        for (let i = 1; i < 5; i++) {
            $('.j-img-' + i).attr('src', '/dlssrvtline2/img/vi-slider-' + i + '.jpg')
        }
    }
    // 设置页面元素语言
    for (let i of configLang) {
        $(i.el).html(setLang(langs)[i.langKey]);
    }
    addMeta('Keywords', getText('keyWords'));
    addMeta('description', getText('description'));
}
const addMeta = (metaname, content) => {
    const meta = document.createElement('meta');
    meta.content = content;
    meta.name = metaname;
    document.getElementsByTagName('head')[0].appendChild(meta);
};

export const getText = key => {
    return setLang(state.lang)[key];
}

export const init = async () => {
    // 初始化语言
    initLang(state.lang);
    await loginInit();
    await basicInit();
    initBindEvent();
};

const loginInit = async () => {
    const res = await api.checkLogin()
    if (res && res.result == 1) {
        state.account = res.data.LOGIN_ACCOUNT
        state.isLogin = true
        await loginInfoInit();
        window.activityDataLayer.push({
            eventName: "login",
            aid: "dlssrvtline2",
            uid: res.data.UID,
            loginAccount: state.account,
            gameId: 274
        })
    }
}

const loginInfoInit = async () => {
    if (isSdk && !state.isBind) {
        state.roleInfo.rid = getParam('roleId') || getParam('role_id');
        state.roleInfo.id = getParam('serverId') || getParam('sid');
        state.roleInfo.rname = getParam('roleName');
        const res = await api.getServer();
        if (res && +res.code === 1) {
            for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].id == state.roleInfo.id) {
                    state.roleInfo.sname = res.data[i].sname;
                    state.roleInfo.sid = res.data[i].sid;
                    break
                }
            }
        } else {
            state.roleInfo.sname = getParam('serverName') || basicForm.server_id;
        }
    } else {
        $('.j-login-btn').hide()
        $('.j-account').html(`${state.account}`).show()
        $('.j-user').show()
    }
}

export const basicInit = async () => {
    const res = await api.getBasicInfo();
    if (res && +res.code === 1) {
        state.account = res.data.loginAccount;
        state.quizMatch = res.data.quizMatch;
        state.matchInfo = res.data.matchInfo;
        state.liveLink = res.data.liveLink;
        state.replayLink = res.data.replayLink;
        initSchedule();
        if (res.data.roleInfo) {
            state.roleInfo.id = res.data.roleInfo.sId;
            state.roleInfo.sid = res.data.roleInfo.serverId;
            state.roleInfo.rid = res.data.roleInfo.roleId;
            state.roleInfo.sname = res.data.roleInfo.serverName;
            state.roleInfo.rname = res.data.roleInfo.roleName;
            roleInfoInit();
            $(".j-bind").addClass("disable");
            state.isBind = true;
            initQuizBlock();
        }
    }
};

export const initQuizBlock = () => {
    //初始化越泰竞猜首轮状态
    if (state.isTh) {
        if (quizArr.includes('16-17')) {
            $('.j-quiz-item-btn1').addClass('active');
            $('.j-quiz-item-btn2').addClass('disable');
        }
        if (quizArr.includes('16-18')) {
            $('.j-quiz-item-btn2').addClass('active');
            $('.j-quiz-item-btn1').addClass('disable');
        }
        if (quizArr.includes('16-19')) {
            $('.j-quiz-item-btn3').addClass('active');
            $('.j-quiz-item-btn4').addClass('disable');
        }
        if (quizArr.includes('16-20')) {
            $('.j-quiz-item-btn4').addClass('active');
            $('.j-quiz-item-btn3').addClass('disable');
        }
        if (quizArr.includes('16-21')) {
            $('.j-quiz-item-btn5').addClass('active');
            $('.j-quiz-item-btn6').addClass('disable');
        }
        if (quizArr.includes('16-22')) {
            $('.j-quiz-item-btn6').addClass('active');
            $('.j-quiz-item-btn5').addClass('disable');
        }
        if (quizArr.includes('16-23')) {
            $('.j-quiz-item-btn7').addClass('active');
            $('.j-quiz-item-btn8').addClass('disable');
        }
        if (quizArr.includes('16-24')) {
            $('.j-quiz-item-btn8').addClass('active');
            $('.j-quiz-item-btn7').addClass('disable');
        }
        if (quizArr.includes('16-25')) {
            $('.j-quiz-item-btn9').addClass('active');
            $('.j-quiz-item-btn10').addClass('disable');
        }
        if (quizArr.includes('16-26')) {
            $('.j-quiz-item-btn10').addClass('active');
            $('.j-quiz-item-btn9').addClass('disable');
        }
        if (quizArr.includes('16-27')) {
            $('.j-quiz-item-btn11').addClass('active');
            $('.j-quiz-item-btn12').addClass('disable');
        }
        if (quizArr.includes('16-28')) {
            $('.j-quiz-item-btn12').addClass('active');
            $('.j-quiz-item-btn11').addClass('disable');
        }
        if (quizArr.includes('16-29')) {
            $('.j-quiz-item-btn13').addClass('active');
            $('.j-quiz-item-btn14').addClass('disable');
        }
        if (quizArr.includes('16-30')) {
            $('.j-quiz-item-btn14').addClass('active');
            $('.j-quiz-item-btn13').addClass('disable');
        }
        if (quizArr.includes('16-31')) {
            $('.j-quiz-item-btn15').addClass('active');
            $('.j-quiz-item-btn16').addClass('disable');
        }
        if (quizArr.includes('16-32')) {
            $('.j-quiz-item-btn16').addClass('active');
            $('.j-quiz-item-btn15').addClass('disable');
        }
    } else {
        if (quizArr.includes('16-1')) {
            $('.j-quiz-item-btn1').addClass('active');
            $('.j-quiz-item-btn2').addClass('disable');
        }
        if (quizArr.includes('16-2')) {
            $('.j-quiz-item-btn2').addClass('active');
            $('.j-quiz-item-btn1').addClass('disable');
        }
        if (quizArr.includes('16-3')) {
            $('.j-quiz-item-btn3').addClass('active');
            $('.j-quiz-item-btn4').addClass('disable');
        }
        if (quizArr.includes('16-4')) {
            $('.j-quiz-item-btn4').addClass('active');
            $('.j-quiz-item-btn3').addClass('disable');
        }
        if (quizArr.includes('16-5')) {
            $('.j-quiz-item-btn5').addClass('active');
            $('.j-quiz-item-btn6').addClass('disable');
        }
        if (quizArr.includes('16-6')) {
            $('.j-quiz-item-btn6').addClass('active');
            $('.j-quiz-item-btn5').addClass('disable');
        }
        if (quizArr.includes('16-7')) {
            $('.j-quiz-item-btn7').addClass('active');
            $('.j-quiz-item-btn8').addClass('disable');
        }
        if (quizArr.includes('16-8')) {
            $('.j-quiz-item-btn8').addClass('active');
            $('.j-quiz-item-btn7').addClass('disable');
        }
        if (quizArr.includes('16-9')) {
            $('.j-quiz-item-btn9').addClass('active');
            $('.j-quiz-item-btn10').addClass('disable');
        }
        if (quizArr.includes('16-10')) {
            $('.j-quiz-item-btn10').addClass('active');
            $('.j-quiz-item-btn9').addClass('disable');
        }
        if (quizArr.includes('16-11')) {
            $('.j-quiz-item-btn11').addClass('active');
            $('.j-quiz-item-btn12').addClass('disable');
        }
        if (quizArr.includes('16-12')) {
            $('.j-quiz-item-btn12').addClass('active');
            $('.j-quiz-item-btn11').addClass('disable');
        }
        if (quizArr.includes('16-13')) {
            $('.j-quiz-item-btn13').addClass('active');
            $('.j-quiz-item-btn14').addClass('disable');
        }
        if (quizArr.includes('16-14')) {
            $('.j-quiz-item-btn14').addClass('active');
            $('.j-quiz-item-btn13').addClass('disable');
        }
        if (quizArr.includes('16-15')) {
            $('.j-quiz-item-btn15').addClass('active');
            $('.j-quiz-item-btn16').addClass('disable');
        }
        if (quizArr.includes('16-16')) {
            $('.j-quiz-item-btn16').addClass('active');
            $('.j-quiz-item-btn15').addClass('disable');
        }
    }
}

export const initSchedule = () => {
    if (state.isTh) {
        $('.j-quiz-item-btn1').attr('data-id', numMap['16-17'].id);
        $('.j-quiz-item-btn2').attr('data-id', numMap['16-18'].id);
        $('.j-quiz-item-btn3').attr('data-id', numMap['16-19'].id);
        $('.j-quiz-item-btn4').attr('data-id', numMap['16-20'].id);
        $('.j-quiz-item-btn5').attr('data-id', numMap['16-21'].id);
        $('.j-quiz-item-btn6').attr('data-id', numMap['16-22'].id);
        $('.j-quiz-item-btn7').attr('data-id', numMap['16-23'].id);
        $('.j-quiz-item-btn8').attr('data-id', numMap['16-24'].id);
    } else {
        $('.j-quiz-item-btn1').attr('data-id', numMap['16-1'].id);
        $('.j-quiz-item-btn2').attr('data-id', numMap['16-2'].id);
        $('.j-quiz-item-btn3').attr('data-id', numMap['16-3'].id);
        $('.j-quiz-item-btn4').attr('data-id', numMap['16-4'].id);
        $('.j-quiz-item-btn5').attr('data-id', numMap['16-5'].id);
        $('.j-quiz-item-btn6').attr('data-id', numMap['16-6'].id);
        $('.j-quiz-item-btn7').attr('data-id', numMap['16-7'].id);
        $('.j-quiz-item-btn8').attr('data-id', numMap['16-8'].id);
    }
    if (state.isTh) {
        $('.j-head-name1').html(numMap['16-17'].name);
        $('.j-head-name2').html(numMap['16-18'].name);
        $('.j-head-name3').html(numMap['16-19'].name);
        $('.j-head-name4').html(numMap['16-20'].name);
        $('.j-head-name5').html(numMap['16-21'].name);
        $('.j-head-name6').html(numMap['16-22'].name);
        $('.j-head-name7').html(numMap['16-23'].name);
        $('.j-head-name8').html(numMap['16-24'].name);
    } else {
        $('.j-head-name1').html(numMap['16-1'].name);
        $('.j-head-name2').html(numMap['16-2'].name);
        $('.j-head-name3').html(numMap['16-3'].name);
        $('.j-head-name4').html(numMap['16-4'].name);
        $('.j-head-name5').html(numMap['16-5'].name);
        $('.j-head-name6').html(numMap['16-6'].name);
        $('.j-head-name7').html(numMap['16-7'].name);
        $('.j-head-name8').html(numMap['16-8'].name);
    }
    for (let i of bagArr) {
        //泰国不能少两字段2-1 2-2
        if (state.matchInfo[i] !== undefined) {
            numMap[i].point = state.matchInfo[i];
        }
        if (state.quizMatch[i] !== undefined) {
            quizArr.push(i)
        }
    }
    if (state.isTh) {
        if (numMap['16-17'].point > 0 || numMap['16-18'].point > 0) {
            if (numMap['16-17'].point > numMap['16-18'].point) {
                $('.j-schedule-item-box1').addClass('succ');
                $('.j-schedule-item-box2').addClass('fail');
                numMap['8-9'].name = numMap['16-17'].name;
                numMap['8-9'].headicon = numMap['16-17'].headicon;
            } else {
                $('.j-schedule-item-box2').addClass('succ');
                $('.j-schedule-item-box1').addClass('fail');
                numMap['8-9'].name = numMap['16-18'].name;
                numMap['8-9'].headicon = numMap['16-18'].headicon;
            }
            numMap['8-9'].id = '8-9';
            $('.j-schedule-item-box-point16-1').html(numMap['16-17'].point);
            $('.j-schedule-item-box-point16-2').html(numMap['16-18'].point);
        }
        if (numMap['16-19'].point > 0 || numMap['16-20'].point > 0) {
            if (numMap['16-19'].point > numMap['16-20'].point) {
                $('.j-schedule-item-box3').addClass('succ');
                $('.j-schedule-item-box4').addClass('fail');
                numMap['8-10'].name = numMap['16-19'].name;
                numMap['8-10'].headicon = numMap['16-19'].headicon;
            } else {
                $('.j-schedule-item-box4').addClass('succ');
                $('.j-schedule-item-box3').addClass('fail');
                numMap['8-10'].name = numMap['16-20'].name;
                numMap['8-10'].headicon = numMap['16-20'].headicon;
            }
            numMap['8-10'].id = '8-10';
            $('.j-schedule-item-box-point16-3').html(numMap['16-19'].point);
            $('.j-schedule-item-box-point16-4').html(numMap['16-20'].point);
        }
        if (numMap['16-21'].point > 0 || numMap['16-22'].point > 0) {
            if (numMap['16-21'].point > numMap['16-22'].point) {
                $('.j-schedule-item-box5').addClass('succ');
                $('.j-schedule-item-box6').addClass('fail');
                numMap['8-11'].name = numMap['16-21'].name;
                numMap['8-11'].headicon = numMap['16-21'].headicon;
            } else {
                $('.j-schedule-item-box6').addClass('succ');
                $('.j-schedule-item-box5').addClass('fail');
                numMap['8-11'].name = numMap['16-22'].name;
                numMap['8-11'].headicon = numMap['16-22'].headicon;
            }
            numMap['8-11'].id = '8-11';
            $('.j-schedule-item-box-point16-5').html(numMap['16-21'].point);
            $('.j-schedule-item-box-point16-6').html(numMap['16-22'].point);
        }
        if (numMap['16-23'].point > 0 || numMap['16-24'].point > 0) {
            if (numMap['16-23'].point > numMap['16-24'].point) {
                $('.j-schedule-item-box7').addClass('succ');
                $('.j-schedule-item-box8').addClass('fail');
                numMap['8-12'].name = numMap['16-23'].name;
                numMap['8-12'].headicon = numMap['16-23'].headicon;
            } else {
                $('.j-schedule-item-box8').addClass('succ');
                $('.j-schedule-item-box7').addClass('fail');
                numMap['8-12'].name = numMap['16-24'].name;
                numMap['8-12'].headicon = numMap['16-24'].headicon;
            }
            numMap['8-12'].id = '8-12';
            $('.j-schedule-item-box-point16-7').html(numMap['16-23'].point);
            $('.j-schedule-item-box-point16-8').html(numMap['16-24'].point);
        }
        if (numMap['16-25'].point > 0 || numMap['16-26'].point > 0) {
            if (numMap['16-25'].point > numMap['16-26'].point) {
                $('.j-schedule-item-box9').addClass('succ');
                $('.j-schedule-item-box10').addClass('fail');
                numMap['8-13'].name = numMap['16-25'].name;
                numMap['8-13'].headicon = numMap['16-25'].headicon;
            } else {
                $('.j-schedule-item-box10').addClass('succ');
                $('.j-schedule-item-box9').addClass('fail');
                numMap['8-13'].name = numMap['16-26'].name;
                numMap['8-13'].headicon = numMap['16-26'].headicon;
            }
            numMap['8-13'].id = '8-13';
            $('.j-schedule-item-box-point16-9').html(numMap['16-25'].point);
            $('.j-schedule-item-box-point16-10').html(numMap['16-26'].point);
        }
        if (numMap['16-27'].point > 0 || numMap['16-28'].point > 0) {
            if (numMap['16-27'].point > numMap['16-28'].point) {
                $('.j-schedule-item-box11').addClass('succ');
                $('.j-schedule-item-box12').addClass('fail');
                numMap['8-14'].name = numMap['16-27'].name;
                numMap['8-14'].headicon = numMap['16-27'].headicon;
            } else {
                $('.j-schedule-item-box12').addClass('succ');
                $('.j-schedule-item-box11').addClass('fail');
                numMap['8-14'].name = numMap['16-28'].name;
                numMap['8-14'].headicon = numMap['16-28'].headicon;
            }
            numMap['8-14'].id = '8-14';
            $('.j-schedule-item-box-point16-11').html(numMap['16-27'].point);
            $('.j-schedule-item-box-point16-12').html(numMap['16-28'].point);
        }
        if (numMap['16-29'].point > 0 || numMap['16-30'].point > 0) {
            if (numMap['16-29'].point > numMap['16-30'].point) {
                $('.j-schedule-item-box13').addClass('succ');
                $('.j-schedule-item-box14').addClass('fail');
                numMap['8-15'].name = numMap['16-29'].name;
                numMap['8-15'].headicon = numMap['16-29'].headicon;
            } else {
                $('.j-schedule-item-box14').addClass('succ');
                $('.j-schedule-item-box13').addClass('fail');
                numMap['8-15'].name = numMap['16-30'].name;
                numMap['8-15'].headicon = numMap['16-30'].headicon;
            }
            numMap['8-15'].id = '8-15';
            $('.j-schedule-item-box-point16-13').html(numMap['16-29'].point);
            $('.j-schedule-item-box-point16-14').html(numMap['16-30'].point);
        }
        if (numMap['16-31'].point > 0 || numMap['16-32'].point > 0) {
            if (numMap['16-31'].point > numMap['16-32'].point) {
                $('.j-schedule-item-box15').addClass('succ');
                $('.j-schedule-item-box16').addClass('fail');
                numMap['8-16'].name = numMap['16-31'].name;
                numMap['8-16'].headicon = numMap['16-31'].headicon;
            } else {
                $('.j-schedule-item-box16').addClass('succ');
                $('.j-schedule-item-box15').addClass('fail');
                numMap['8-16'].name = numMap['16-32'].name;
                numMap['8-16'].headicon = numMap['16-32'].headicon;
            }
            numMap['8-16'].id = '8-16';
            $('.j-schedule-item-box-point16-15').html(numMap['16-31'].point);
            $('.j-schedule-item-box-point16-16').html(numMap['16-32'].point);
        }
        if (numMap['8-9'].point > 0 || numMap['8-10'].point > 0) {
            if (numMap['8-9'].point > numMap['8-10'].point) {
                $('.j-schedule-item-box17').addClass('succ');
                $('.j-schedule-item-box18').addClass('fail');
                numMap['4-5'].name = numMap['8-9'].name;
                numMap['4-5'].headicon = numMap['8-9'].headicon;
            } else {
                $('.j-schedule-item-box18').addClass('succ');
                $('.j-schedule-item-box17').addClass('fail');
                numMap['4-5'].name = numMap['8-10'].name;
                numMap['4-5'].headicon = numMap['8-10'].headicon;
            }
            numMap['4-5'].id = '4-5';
            $('.j-schedule-item-box-point8-1').html(numMap['8-9'].point);
            $('.j-schedule-item-box-point8-2').html(numMap['8-10'].point);
        }
        if (numMap['8-11'].point > 0 || numMap['8-12'].point > 0) {
            if (numMap['8-11'].point > numMap['8-12'].point) {
                $('.j-schedule-item-box19').addClass('succ');
                $('.j-schedule-item-box20').addClass('fail');
                numMap['4-6'].name = numMap['8-11'].name;
                numMap['4-6'].headicon = numMap['8-11'].headicon;
            } else {
                $('.j-schedule-item-box20').addClass('succ');
                $('.j-schedule-item-box19').addClass('fail');
                numMap['4-6'].name = numMap['8-12'].name;
                numMap['4-6'].headicon = numMap['8-12'].headicon;
            }
            numMap['4-6'].id = '4-6';
            $('.j-schedule-item-box-point8-3').html(numMap['8-11'].point);
            $('.j-schedule-item-box-point8-4').html(numMap['8-12'].point);
        }
        if (numMap['8-13'].point > 0 || numMap['8-14'].point > 0) {
            if (numMap['8-13'].point > numMap['8-14'].point) {
                $('.j-schedule-item-box21').addClass('succ');
                $('.j-schedule-item-box22').addClass('fail');
                numMap['4-7'].name = numMap['8-13'].name;
                numMap['4-7'].headicon = numMap['8-13'].headicon;
            } else {
                $('.j-schedule-item-box22').addClass('succ');
                $('.j-schedule-item-box21').addClass('fail');
                numMap['4-7'].name = numMap['8-14'].name;
                numMap['4-7'].headicon = numMap['8-14'].headicon;
            }
            numMap['4-7'].id = '4-7';
            $('.j-schedule-item-box-point8-5').html(numMap['8-13'].point);
            $('.j-schedule-item-box-point8-6').html(numMap['8-14'].point);
        }
        if (numMap['8-15'].point > 0 || numMap['8-16'].point > 0) {
            if (numMap['8-15'].point > numMap['8-16'].point) {
                $('.j-schedule-item-box23').addClass('succ');
                $('.j-schedule-item-box24').addClass('fail');
                numMap['4-8'].name = numMap['8-15'].name;
                numMap['4-8'].headicon = numMap['8-15'].headicon;
            } else {
                $('.j-schedule-item-box24').addClass('succ');
                $('.j-schedule-item-box23').addClass('fail');
                numMap['4-8'].name = numMap['8-16'].name;
                numMap['4-8'].headicon = numMap['8-16'].headicon;
            }
            numMap['4-8'].id = '4-8';
            $('.j-schedule-item-box-point8-7').html(numMap['8-15'].point);
            $('.j-schedule-item-box-point8-8').html(numMap['8-16'].point);
        }
        if (numMap['4-5'].point > 0 || numMap['4-6'].point > 0) {
            if (numMap['4-5'].point > numMap['4-6'].point) {
                $('.j-schedule-item-box25').addClass('succ');
                $('.j-schedule-item-box26').addClass('fail');
                numMap['1-3'].name = numMap['4-5'].name;
                numMap['1-3'].headicon = numMap['4-5'].headicon;
            } else {
                $('.j-schedule-item-box26').addClass('succ');
                $('.j-schedule-item-box25').addClass('fail');
                numMap['1-3'].name = numMap['4-6'].name;
                numMap['1-3'].headicon = numMap['4-6'].headicon;
            }
            numMap['1-3'].id = '1-3';
            $('.j-schedule-item-box-point4-1').html(numMap['4-5'].point);
            $('.j-schedule-item-box-point4-2').html(numMap['4-6'].point);
        }
        if (numMap['4-7'].point > 0 || numMap['4-8'].point > 0) {
            if (numMap['4-7'].point > numMap['4-8'].point) {
                $('.j-schedule-item-box27').addClass('succ');
                $('.j-schedule-item-box28').addClass('fail');
                numMap['1-4'].name = numMap['4-7'].name;
                numMap['1-4'].headicon = numMap['4-7'].headicon;
            } else {
                $('.j-schedule-item-box28').addClass('succ');
                $('.j-schedule-item-box27').addClass('fail');
                numMap['1-4'].name = numMap['4-8'].name;
                numMap['1-4'].headicon = numMap['4-8'].headicon;
            }
            numMap['1-4'].id = '1-4';
            $('.j-schedule-item-box-point4-3').html(numMap['4-7'].point);
            $('.j-schedule-item-box-point4-4').html(numMap['4-8'].point);
        }
        if (numMap['1-3'].point > 0 || numMap['1-4'].point > 0) {
            if (numMap['1-3'].point > numMap['1-4'].point) {
                $('.j-schedule-item-box29').addClass('succ');
                $('.j-schedule-item-box30').addClass('fail');

            } else {
                $('.j-schedule-item-box30').addClass('succ');
                $('.j-schedule-item-box29').addClass('fail');

            }
            $('.j-schedule-item-box-point1-1').html(numMap['1-3'].point);
            $('.j-schedule-item-box-point1-2').html(numMap['1-4'].point);
        }
    } else {
        if (numMap['16-1'].point > 0 || numMap['16-2'].point > 0) {
            if (numMap['16-1'].point > numMap['16-2'].point) {
                $('.j-schedule-item-box1').addClass('succ');
                $('.j-schedule-item-box2').addClass('fail');
                numMap['8-1'].name = numMap['16-1'].name;
                numMap['8-1'].headicon = numMap['16-1'].headicon;
            } else {
                $('.j-schedule-item-box2').addClass('succ');
                $('.j-schedule-item-box1').addClass('fail');
                numMap['8-1'].name = numMap['16-2'].name;
                numMap['8-1'].headicon = numMap['16-2'].headicon;
            }
            numMap['8-1'].id = '8-1';
            $('.j-schedule-item-box-point16-1').html(numMap['16-1'].point);
            $('.j-schedule-item-box-point16-2').html(numMap['16-2'].point);
        }
        if (numMap['16-3'].point > 0 || numMap['16-4'].point > 0) {
            if (numMap['16-3'].point > numMap['16-4'].point) {
                $('.j-schedule-item-box3').addClass('succ');
                $('.j-schedule-item-box4').addClass('fail');
                numMap['8-2'].name = numMap['16-3'].name;
                numMap['8-2'].headicon = numMap['16-3'].headicon;
            } else {
                $('.j-schedule-item-box4').addClass('succ');
                $('.j-schedule-item-box3').addClass('fail');
                numMap['8-2'].name = numMap['16-4'].name;
                numMap['8-2'].headicon = numMap['16-4'].headicon;
            }
            numMap['8-2'].id = '8-2';
            $('.j-schedule-item-box-point16-3').html(numMap['16-3'].point);
            $('.j-schedule-item-box-point16-4').html(numMap['16-4'].point);
        }
        if (numMap['16-5'].point > 0 || numMap['16-6'].point > 0) {
            if (numMap['16-5'].point > numMap['16-6'].point) {
                $('.j-schedule-item-box5').addClass('succ');
                $('.j-schedule-item-box6').addClass('fail');
                numMap['8-3'].name = numMap['16-5'].name;
                numMap['8-3'].headicon = numMap['16-5'].headicon;
            } else {
                $('.j-schedule-item-box6').addClass('succ');
                $('.j-schedule-item-box5').addClass('fail');
                numMap['8-3'].name = numMap['16-6'].name;
                numMap['8-3'].headicon = numMap['16-6'].headicon;
            }
            numMap['8-3'].id = '8-3';
            $('.j-schedule-item-box-point16-5').html(numMap['16-5'].point);
            $('.j-schedule-item-box-point16-6').html(numMap['16-6'].point);
        }
        if (numMap['16-7'].point > 0 || numMap['16-8'].point > 0) {
            if (numMap['16-7'].point > numMap['16-8'].point) {
                $('.j-schedule-item-box7').addClass('succ');
                $('.j-schedule-item-box8').addClass('fail');
                numMap['8-4'].name = numMap['16-7'].name;
                numMap['8-4'].headicon = numMap['16-7'].headicon;
            } else {
                $('.j-schedule-item-box8').addClass('succ');
                $('.j-schedule-item-box7').addClass('fail');
                numMap['8-4'].name = numMap['16-8'].name;
                numMap['8-4'].headicon = numMap['16-8'].headicon;
            }
            numMap['8-4'].id = '8-4';
            $('.j-schedule-item-box-point16-7').html(numMap['16-7'].point);
            $('.j-schedule-item-box-point16-8').html(numMap['16-8'].point);
        }
        if (numMap['16-9'].point > 0 || numMap['16-10'].point > 0) {
            if (numMap['16-9'].point > numMap['16-10'].point) {
                $('.j-schedule-item-box9').addClass('succ');
                $('.j-schedule-item-box10').addClass('fail');
                numMap['8-5'].name = numMap['16-9'].name;
                numMap['8-5'].headicon = numMap['16-9'].headicon;
            } else {
                $('.j-schedule-item-box10').addClass('succ');
                $('.j-schedule-item-box9').addClass('fail');
                numMap['8-5'].name = numMap['16-10'].name;
                numMap['8-5'].headicon = numMap['16-10'].headicon;
            }
            numMap['8-5'].id = '8-5';
            $('.j-schedule-item-box-point16-9').html(numMap['16-9'].point);
            $('.j-schedule-item-box-point16-10').html(numMap['16-10'].point);
        }
        if (numMap['16-11'].point > 0 || numMap['16-12'].point > 0) {
            if (numMap['16-11'].point > numMap['16-12'].point) {
                $('.j-schedule-item-box11').addClass('succ');
                $('.j-schedule-item-box12').addClass('fail');
                numMap['8-6'].name = numMap['16-11'].name;
                numMap['8-6'].headicon = numMap['16-11'].headicon;
            } else {
                $('.j-schedule-item-box12').addClass('succ');
                $('.j-schedule-item-box11').addClass('fail');
                numMap['8-6'].name = numMap['16-12'].name;
                numMap['8-6'].headicon = numMap['16-12'].headicon;
            }
            numMap['8-6'].id = '8-6';
            $('.j-schedule-item-box-point16-11').html(numMap['16-11'].point);
            $('.j-schedule-item-box-point16-12').html(numMap['16-12'].point);
        }
        if (numMap['16-13'].point > 0 || numMap['16-14'].point > 0) {
            if (numMap['16-13'].point > numMap['16-14'].point) {
                $('.j-schedule-item-box13').addClass('succ');
                $('.j-schedule-item-box14').addClass('fail');
                numMap['8-7'].name = numMap['16-13'].name;
                numMap['8-7'].headicon = numMap['16-13'].headicon;
            } else {
                $('.j-schedule-item-box14').addClass('succ');
                $('.j-schedule-item-box13').addClass('fail');
                numMap['8-7'].name = numMap['16-14'].name;
                numMap['8-7'].headicon = numMap['16-14'].headicon;
            }
            numMap['8-7'].id = '8-7';
            $('.j-schedule-item-box-point16-13').html(numMap['16-13'].point);
            $('.j-schedule-item-box-point16-14').html(numMap['16-14'].point);
        }
        if (numMap['16-15'].point > 0 || numMap['16-16'].point > 0) {
            if (numMap['16-15'].point > numMap['16-16'].point) {
                $('.j-schedule-item-box15').addClass('succ');
                $('.j-schedule-item-box16').addClass('fail');
                numMap['8-8'].name = numMap['16-15'].name;
                numMap['8-8'].headicon = numMap['16-15'].headicon;
            } else {
                $('.j-schedule-item-box16').addClass('succ');
                $('.j-schedule-item-box15').addClass('fail');
                numMap['8-8'].name = numMap['16-16'].name;
                numMap['8-8'].headicon = numMap['16-16'].headicon;
            }
            numMap['8-8'].id = '8-8';
            $('.j-schedule-item-box-point16-15').html(numMap['16-15'].point);
            $('.j-schedule-item-box-point16-16').html(numMap['16-16'].point);
        }
        if (numMap['8-1'].point > 0 || numMap['8-2'].point > 0) {
            if (numMap['8-1'].point > numMap['8-2'].point) {
                $('.j-schedule-item-box17').addClass('succ');
                $('.j-schedule-item-box18').addClass('fail');
                numMap['4-1'].name = numMap['8-1'].name;
                numMap['4-1'].headicon = numMap['8-1'].headicon;
            } else {
                $('.j-schedule-item-box18').addClass('succ');
                $('.j-schedule-item-box17').addClass('fail');
                numMap['4-1'].name = numMap['8-2'].name;
                numMap['4-1'].headicon = numMap['8-2'].headicon;
            }
            numMap['4-1'].id = '4-1';
            $('.j-schedule-item-box-point8-1').html(numMap['8-1'].point);
            $('.j-schedule-item-box-point8-2').html(numMap['8-2'].point);
        }
        if (numMap['8-3'].point > 0 || numMap['8-4'].point > 0) {
            if (numMap['8-3'].point > numMap['8-4'].point) {
                $('.j-schedule-item-box19').addClass('succ');
                $('.j-schedule-item-box20').addClass('fail');
                numMap['4-2'].name = numMap['8-3'].name;
                numMap['4-2'].headicon = numMap['8-3'].headicon;
            } else {
                $('.j-schedule-item-box20').addClass('succ');
                $('.j-schedule-item-box19').addClass('fail');
                numMap['4-2'].name = numMap['8-4'].name;
                numMap['4-2'].headicon = numMap['8-4'].headicon;
            }
            numMap['4-2'].id = '4-2';
            $('.j-schedule-item-box-point8-3').html(numMap['8-3'].point);
            $('.j-schedule-item-box-point8-4').html(numMap['8-4'].point);
        }
        if (numMap['8-5'].point > 0 || numMap['8-6'].point > 0) {
            if (numMap['8-5'].point > numMap['8-6'].point) {
                $('.j-schedule-item-box21').addClass('succ');
                $('.j-schedule-item-box22').addClass('fail');
                numMap['4-3'].name = numMap['8-5'].name;
                numMap['4-3'].headicon = numMap['8-5'].headicon;
            } else {
                $('.j-schedule-item-box22').addClass('succ');
                $('.j-schedule-item-box21').addClass('fail');
                numMap['4-3'].name = numMap['8-6'].name;
                numMap['4-3'].headicon = numMap['8-6'].headicon;
            }
            numMap['4-3'].id = '4-3';
            $('.j-schedule-item-box-point8-5').html(numMap['8-5'].point);
            $('.j-schedule-item-box-point8-6').html(numMap['8-6'].point);
        }
        if (numMap['8-7'].point > 0 || numMap['8-8'].point > 0) {
            if (numMap['8-7'].point > numMap['8-8'].point) {
                $('.j-schedule-item-box23').addClass('succ');
                $('.j-schedule-item-box24').addClass('fail');
                numMap['4-4'].name = numMap['8-7'].name;
                numMap['4-4'].headicon = numMap['8-7'].headicon;
            } else {
                $('.j-schedule-item-box24').addClass('succ');
                $('.j-schedule-item-box23').addClass('fail');
                numMap['4-4'].name = numMap['8-8'].name;
                numMap['4-4'].headicon = numMap['8-8'].headicon;
            }
            numMap['4-4'].id = '4-4';
            $('.j-schedule-item-box-point8-7').html(numMap['8-7'].point);
            $('.j-schedule-item-box-point8-8').html(numMap['8-8'].point);
        }
        if (numMap['4-1'].point > 0 || numMap['4-2'].point > 0) {
            if (numMap['4-1'].point > numMap['4-2'].point) {
                $('.j-schedule-item-box25').addClass('succ');
                $('.j-schedule-item-box26').addClass('fail');
                numMap['1-1'].name = numMap['4-1'].name;
                numMap['1-1'].headicon = numMap['4-1'].headicon;
                numMap['2-1'].name = numMap['4-2'].name;
                numMap['2-1'].headicon = numMap['4-2'].headicon;
                ltbClass = 'bottom';
            } else {
                $('.j-schedule-item-box26').addClass('succ');
                $('.j-schedule-item-box25').addClass('fail');
                numMap['1-1'].name = numMap['4-2'].name;
                numMap['1-1'].headicon = numMap['4-2'].headicon;
                numMap['2-1'].name = numMap['4-1'].name;
                numMap['2-1'].headicon = numMap['4-1'].headicon;
                ltbClass = 'top';
            }
            numMap['1-1'].id = '1-1';
            numMap['2-1'].id = '2-1';
            $('.j-schedule-item-box-point4-1').html(numMap['4-1'].point);
            $('.j-schedule-item-box-point4-2').html(numMap['4-2'].point);
        }
        if (numMap['4-3'].point > 0 || numMap['4-4'].point > 0) {
            if (numMap['4-3'].point > numMap['4-4'].point) {
                $('.j-schedule-item-box27').addClass('succ');
                $('.j-schedule-item-box28').addClass('fail');
                numMap['1-2'].name = numMap['4-3'].name;
                numMap['1-2'].headicon = numMap['4-3'].headicon;
                numMap['2-2'].name = numMap['4-4'].name;
                numMap['2-2'].headicon = numMap['4-4'].headicon;
                rtbClass = 'bottom';
            } else {
                $('.j-schedule-item-box28').addClass('succ');
                $('.j-schedule-item-box27').addClass('fail');
                numMap['1-2'].name = numMap['4-4'].name;
                numMap['1-2'].headicon = numMap['4-4'].headicon;
                numMap['2-2'].name = numMap['4-3'].name;
                numMap['2-2'].headicon = numMap['4-3'].headicon;
                rtbClass = 'top';
            }
            numMap['1-2'].id = '1-2';
            numMap['2-2'].id = '2-2';
            $('.j-schedule-item-box-point4-3').html(numMap['4-3'].point);
            $('.j-schedule-item-box-point4-4').html(numMap['4-4'].point);
        }
        if (numMap['1-1'].point > 0 || numMap['1-2'].point > 0) {
            if (numMap['1-1'].point > numMap['1-2'].point) {
                $('.j-schedule-item-box29').addClass('succ');
                $('.j-schedule-item-box30').addClass('fail');

            } else {
                $('.j-schedule-item-box30').addClass('succ');
                $('.j-schedule-item-box29').addClass('fail');

            }
            $('.j-schedule-item-box-point1-1').html(numMap['1-1'].point);
            $('.j-schedule-item-box-point1-2').html(numMap['1-2'].point);
        }
        if (numMap['2-1'].point > 0 || numMap['2-2'].point > 0) {
            if (numMap['2-1'].point > numMap['2-2'].point) {
                $(".j-left-flag").addClass(ltbClass);
            } else {
                $(".j-right-flag").addClass(rtbClass);
            }
        }
    }
    const scheduleMap = {
        '16-1': '16-1',
        '16-2': '16-2',
        '16-3': '16-3',
        '16-4': '16-4',
        '16-5': '16-5',
        '16-6': '16-6',
        '16-7': '16-7',
        '16-8': '16-8',
        '16-9': '16-9',
        '16-10': '16-10',
        '16-11': '16-11',
        '16-12': '16-12',
        '16-13': '16-13',
        '16-14': '16-14',
        '16-15': '16-15',
        '16-16': '16-16',
        '16-17': '16-1',
        '16-18': '16-2',
        '16-19': '16-3',
        '16-20': '16-4',
        '16-21': '16-5',
        '16-22': '16-6',
        '16-23': '16-7',
        '16-24': '16-8',
        '16-25': '16-9',
        '16-26': '16-10',
        '16-27': '16-11',
        '16-28': '16-12',
        '16-29': '16-13',
        '16-30': '16-14',
        '16-31': '16-15',
        '16-32': '16-16',
        '8-1': '8-1',
        '8-2': '8-2',
        '8-3': '8-3',
        '8-4': '8-4',
        '8-5': '8-5',
        '8-6': '8-6',
        '8-7': '8-7',
        '8-8': '8-8',
        '8-9': '8-1',
        '8-10': '8-2',
        '8-11': '8-3',
        '8-12': '8-4',
        '8-13': '8-5',
        '8-14': '8-6',
        '8-15': '8-7',
        '8-16': '8-8',
        '4-1': '4-1',
        '4-2': '4-2',
        '4-3': '4-3',
        '4-4': '4-4',
        '4-5': '4-1',
        '4-6': '4-2',
        '4-7': '4-3',
        '4-8': '4-4',
        '1-1': '1-1',
        '1-2': '1-2',
        '1-3': '1-1',
        '1-4': '1-2',
    }
    if (state.isTh) {
        for (let i of thbagArr) {
            if (numMap[i].name) {
                $('.j-schedule-item-box-name' + scheduleMap[i]).html(numMap[i].name);
            } else {
                $('.j-schedule-item-box-name' + scheduleMap[i]).html("???");
            }
        }
    } else {
        for (let i of vibagArr) {
            if (numMap[i].name) {
                $('.j-schedule-item-box-name' + scheduleMap[i]).html(numMap[i].name);
            } else {
                $('.j-schedule-item-box-name' + scheduleMap[i]).html("???");
            }
        }
    }


}

export const checkLogin = () => {
    if (!state.isLogin) {
        gotoLogin()
        return false
    }
    return true
}

export const gotoLogin = () => {
    window.location.href = `https://gabres.${arr[1]}.com/platform/login.html?gameId=274&device=${window.platform.isPhone() ? 2 : 1
        }&forward=${encodeURIComponent(window.location.href)}`
}

export const checkLoginAndBind = callbackFunction => {
    if (checkLogin()) {
        if (state.isBind) {
            callbackFunction()
        }
    }
}

export const jumpLink = link => {
    if (isSdk) {
        sdkOpenLink(link);
    } else {
        window.open(link)
    }
}

export const roleInfoInit = () => {
    $('.j-bind').html(`[${state.roleInfo.sname} - ${state.roleInfo.rname}]`)
}